import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import * as DateHelpers from './DateHelpers';

interface AllocateMoveMultipleProps {
    moveDetails: MoveDetails;
    showOnHireDate: boolean;        //hide on hire date if we are just moving pick ups
    showOffHireDate: boolean;       //show off hire date if we are moving a single pickup
    showModal: boolean;
    hideModal(): void;
    update(moveDetails: MoveDetails): void;
    save(): void;
}

interface AllocateMoveMultipleModal {
    errors: any;
    loading: boolean;
}

interface MoveDetails {
    scheduleDate: string;
    onhireDate: string;
    offhireDate: string;
}

export default class AllocateMoveMultipleItemsModal extends React.Component<AllocateMoveMultipleProps, AllocateMoveMultipleModal> {
    constructor(props: AllocateMoveMultipleProps) {
        super(props);
        this.state = {
            errors: {},
            loading: false
        }
    }

    handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
            this.setState({ errors: errors });
        }

        //update props item
        var moveDetails = this.props.moveDetails;
        let newMoveDetails: any = moveDetails;      

        //update errors
        let change: any = {};
        change = newMoveDetails;
        change[e.target.name] = e.target.value;

        this.props.update(change);
    }

    hideModal = () => {
        this.setState({ errors: {} });
        this.props.hideModal();
    }

    validate = () => {
        let fields = this.props.moveDetails;
        let errors: any = {};
        let formIsValid = true;

        if (!fields.scheduleDate) {
            formIsValid = false;
            errors["scheduleDate"] = "Schedule Date is required";
        } else if (!DateHelpers.isValidDate(fields.scheduleDate)) {
            formIsValid = false;
            errors["scheduleDate"] = "Schedule Date must be a valid date";
        }

        if (this.props.showOnHireDate) {
            if (!fields.onhireDate) {
                formIsValid = false;
                errors["onhireDate"] = "On Hire Date is required";
            } else if (!DateHelpers.isValidDate(fields.onhireDate)) {
                formIsValid = false;
                errors["onhireDate"] = "On Hire Date must be a valid date";
            }

            if (formIsValid && !DateHelpers.compareDate(fields.scheduleDate, fields.onhireDate)) {
                formIsValid = false;
                errors["onhireDate"] = "On Hire Date must be >= Schedule Date";
            }
        }

        if (this.props.showOffHireDate) {
            if (!fields.offhireDate) {
                formIsValid = false;
                errors["offhireDate"] = "Off Hire Date is required";
            } else if (!DateHelpers.isValidDate(fields.offhireDate)) {
                formIsValid = false;
                errors["offhireDate"] = "Off Hire Date must be a valid date";
            }

            if (formIsValid && !DateHelpers.compareDate(fields.offhireDate, fields.scheduleDate)) {
                formIsValid = false;
                errors["offhireDate"] = "Off Hire Date must be <= Schedule Date";
            }
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    save = (e: any) => {
        e.preventDefault();

        if (this.validate()) {
            this.props.save();
        }
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return (<div>
            {contents}
        </div>);
    }

    renderDetails = () => {
        return (
            <div className="static-modal">
                <Modal show={this.props.showModal} onHide={this.hideModal}>
                    <Modal.Header className="modal__header--colour">
                        <Modal.Title>Move Multiple Jobs</Modal.Title>
                        <button type="button" className="close" onClick={this.hideModal}>&times;</button>
                    </Modal.Header>
                    <Modal.Body>
                        <label className="input-group" htmlFor="scheduleDate">
                            <span className="label">Schedule Date</span>
                            <input type='date' id="scheduleDate" name="scheduleDate" className='input allocate__extendwidth' value={this.props.moveDetails.scheduleDate} onChange={(e) => this.handleChange(e)}></input>
                        </label>
                        <span className="label errors">{this.state.errors["scheduleDate"]}</span>
                        
                        <label className={this.props.showOnHireDate ? "input-group" : "hidden"} htmlFor="onhireDate">
                            <span className="label">On Hire Date</span>
                            <input type='date' id="onhireDate" name="onhireDate" className='input allocate__extendwidth' value={this.props.moveDetails.onhireDate} onChange={(e) => this.handleChange(e)}></input>
                        </label>
                        <span className="label errors">{this.state.errors["onhireDate"]}</span>

                        <label className={this.props.showOffHireDate ? "input-group" : "hidden"} htmlFor="offhireDate">
                            <span className="label">Off Hire Date</span>
                            <input type='date' id="offhireDate" name="offhireDate" className='input allocate__extendwidth' value={this.props.moveDetails.offhireDate} onChange={(e) => this.handleChange(e)}></input>
                        </label>
                        <span className="label errors">{this.state.errors["offhireDate"]}</span>
                    </Modal.Body>

                    <Modal.Footer>
                        <button className="popup-button--yes" onClick={this.save}>Save</button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}